import * as R from 'ramda';

import { handledGetFetch, handledPostFetch } from '../../submodules/shared/utils/api-base';

import { PATHS } from './paths';
import { buildUrl } from './url';

export const getAccountAccess = (payload) =>
    handledGetFetch(buildUrl(PATHS.accountAccessById(R.propOr('', 'accountId', payload))));

export const postAccountAccess = (payload) => handledPostFetch(buildUrl(PATHS.accountAccessById(payload.id)), payload);

// NOTE: named put* but intentionally issues a POST to the un-suffixed path,
// preserving the prior behavior exactly.
export const putAccountAccess = (payload) => handledPostFetch(buildUrl(PATHS.accountAccess), payload);
